import { render, staticRenderFns } from "./AdminRetailer.vue?vue&type=template&id=5adac9dc&scoped=true"
import script from "./AdminRetailer.vue?vue&type=script&lang=js"
export * from "./AdminRetailer.vue?vue&type=script&lang=js"
import style0 from "./AdminRetailer.vue?vue&type=style&index=0&id=5adac9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5adac9dc",
  null
  
)

export default component.exports